import { render, staticRenderFns } from "./RecommendKnowledge.vue?vue&type=template&id=3ae4dd66&scoped=true&"
import script from "./RecommendKnowledge.vue?vue&type=script&lang=js&"
export * from "./RecommendKnowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae4dd66",
  null
  
)

export default component.exports